import {GO_TO_NEXT_DATE, GO_TO_PREV_DATE} from "./constants"

export const gotToNextDate = function (){
  return {
    type: GO_TO_NEXT_DATE 
  }
}


export const goToPrevDate = function(){
  return {
    type: GO_TO_PREV_DATE
  }
}
